import React from 'react';
import { getConcernSeverityTag } from '../../utils/reportSeverity';

export default function SkinConcernsPriority({
  items = [],
  improvementPotential = null,
  maxItems = 5,
}) {
  const list = items.slice(0, maxItems);
  if (!list.length) return null;

  const pct = improvementPotential != null ? Math.max(0, Math.min(100, Number(improvementPotential))) : null;
  const donutStyle = pct != null
    ? { background: `conic-gradient(#6D28D9 ${pct}%, #E9D5FF ${pct}% 100%)` }
    : undefined;

  return (
    <div className="skin-report-priority">
      <ol className="skin-report-priority-list">
        {list.map((item, idx) => {
          const tag = getConcernSeverityTag(item.score);
          return (
            <li key={item.class_name || item.key || idx}>
              <span className={`skin-report-priority-tag skin-report-priority-tag--${tag.tone}`}>{tag.label}</span>
              <span className="skin-report-priority-num">{idx + 1}</span>
              <span className="skin-report-priority-name">{item.label || item.class_name}</span>
            </li>
          );
        })}
      </ol>
      {pct != null ? (
        <div className="skin-report-priority-donut-wrap">
          <div className="skin-report-priority-donut" style={donutStyle} role="img" aria-label={`${pct}% overall improvement potential`}>
            <div className="skin-report-priority-donut-inner">
              <strong>{pct}%</strong>
              <span>Overall Improvement Potential</span>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
